import dayjs from 'dayjs';

export const toDDMMYYYY = val => {
  if (!val) return null
  if (typeof val === 'string' && val.includes('/')) return val // already DD/MM/YYYY
  const parts = String(val).split('-') // expect YYYY-MM-DD
  if (parts.length === 3) {
    return `${parts[2]}/${parts[1]}/${parts[0]}` // DD/MM/YYYY
  }
  return val;
};

export const toDisplayDate = (dateStr) => {
  if (!dateStr) return '';
  let s = String(dateStr);
  // Strip time if present (e.g., YYYY-MM-DDTHH:mm:ss)
  if (s.includes('T')) s = s.split('T')[0];
  // Already in DD/MM/YYYY
  if (s.includes('/')) return s;
  // Convert YYYY-MM-DD -> DD/MM/YYYY
  if (s.includes('-')) {
    const [year, month, day] = s.split('-');
    if (year && month && day) return `${day}/${month}/${year}`;
  }
  return s;
};

export const normalizeDate = (dateStr) => {
  if (!dateStr) return "";
  return dayjs(dateStr, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("DD/MM/YYYY");
};
